<template>
  <div class="special_article">
    <h3 class="title">
      <img :src="titleImage" alt="落とし穴">
    </h3>
    <div class="image">
      <img :src="image" alt="">
    </div>
    <div class="text" v-html="text">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecialArticle',
  props: {
    titleImage: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.special_article {
  max-width: 900px;
  width: 90%;
  margin: 0 auto;
  padding-top: 100px;
  position: relative;
}
.title {
  width: 90%;
  max-width: 270px;
  margin: 0 auto;
  @media print,screen and (max-width: 767px) {
    max-width: 150px;
  }
}
.image {
  width: 90%;
  max-width: 900px;
  margin: 0 auto;
  margin-top: 50px;
  @media print,screen and (max-width: 767px) {
    margin-top: 20px;
  }
}
.text {
  width: 90%;
  background-color: #ebfae1;
  border-radius: 20px;
  box-shadow: 10px 10px #00797f61;
  color: #00797f;
  padding: 30px;
  position: relative;
  box-sizing: border-box;
  margin: 0 auto;
  font-weight: bold;
  text-align: justify;
  .underline {
    background: linear-gradient(transparent 75%, #fff799 75%);
  }
  &:before {
    content: "";
    width: 0;
    height: 0;
    top: -30px;
    position: absolute;
    border: 15px solid transparent;
    border-bottom: 15px solid #ebfae1;
    left: 0;
    right: 0;
    margin: auto;
  }
}
.special_article ::v-deep .underline {
  background: linear-gradient(transparent 50%, #fbff00 50%);
}
</style>